import React, { Component } from 'react'
import { Button, Row, Col } from 'antd'

import { connect } from 'react-redux'
import { act_setHeadTitle } from '../../redux/actions'

import './not-found.less'

class NotFound extends Component {
    goHome = () => {
        this.props.act_setHeadTitle('首頁')
        this.props.history.replace('/home')
    }

    render = () => {
        return (
            <Row className='not-found'>
                <Col span={12} className='left'></Col>
                <Col span={12} className='right'>
                    <h2>抱歉，請所瀏覽的頁面不存在</h2>
                    <div>
                        <Button type='primary' onClick={this.goHome}>回到首頁</Button>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default connect(
    null,
    {act_setHeadTitle}
)(NotFound)